import React from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

// Import required modules
import { Autoplay, Pagination } from "swiper/modules";

// Import your custom CSS file
import "../../styles/employeeDetails.css";

const Testimonials = () => {
  const testimonialsData = [
    {
      id: 1,
      text: " I landed a job in Dubai after completing US CMA at Madhi Academy.",
      name: "Shreya P",
      role: "Student",
      rating: 5,
    },
    {
      id: 2,
      text: "The CPA training and career guidance here is top-notch.",
      name: "Arjun M",
      role: "Student",
      rating: 5,
    },
    {
      id: 3,
      text: "EA certification helped me build my own US tax consultancy.",
      name: "Rahul S",
      role: "Student",
      rating: 5,
    },
  
  ];

  // Helper to render stars
  const renderStars = (count) => {
    return Array(count)
      .fill(0)
      .map((_, i) => <span key={i} className="star">★</span>);
  };

  return (
    <section className="testimonials-section">
      <div className="container">
        <Swiper
          spaceBetween={30}
          slidesPerView={1} // Default (Mobile)
          loop={true}
          centeredSlides={false}
          autoplay={{
            delay: 4000,
            disableOnInteraction: false,
          }}
          pagination={{
            clickable: true,
          }}
          breakpoints={{
            // 1. Mobile (Portrait) -> 1 Card
            0: {
              slidesPerView: 1,
              spaceBetween: 20,
            },
            // 2. Tablet / Small Laptop -> 2 Cards
            768: {
              slidesPerView: 2,
              spaceBetween: 30,
            },
            // 3. Desktop (Wide) -> 3 Cards
            1024: {
              slidesPerView: 3,
              spaceBetween: 30,
            },
          }}
          modules={[Autoplay, Pagination]}
          className="testimonials-swiper pb-5" // Added padding bottom for pagination dots
        >
          {testimonialsData.map((item) => (
            <SwiperSlide key={item.id}>
              <div className="testimonial-card-wrapper">
                
                {/* Quote Box */}
                <div className="quote-box">
                  <p className="quote-text">{item.text}</p>
                  
                  {/* Floating Profile Circle */}
                  <div className="profile-wrapper">
                    <div className="profile-circle">
                      <svg 
                        xmlns="http://www.w3.org/2000/svg" 
                        viewBox="0 0 16 16" 
                        className="profile-icon"
                      >
                         <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"/>
                      </svg>
                    </div>
                  </div>
                </div>

                {/* Info Section */}
                <div className="student-info">
                  <div className="rating-stars">
                    {renderStars(item.rating)}
                  </div>
                  <h4 className="student-name">{item.name}</h4>
                  <span className="student-role">{item.role}</span>
                </div>

              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>  
  );
};

export default Testimonials;